import { Fragment, useState } from 'react';
import { Breadcrumbs } from '../../../Themes/Components/AbstractElements';
import Chart from '../Components/Chart';
import FiltrarPeriodo from '../Components/FiltrarPeriodo';
import { DASHBOARD_EXPORTACAO_GRAFICOS } from '../../../Themes/Config/appConfig';
import { Container, Row } from 'reactstrap';

const DashboardExportacao = () => {
  const graficos = JSON.parse(localStorage.getItem(DASHBOARD_EXPORTACAO_GRAFICOS));
  const [filtro, setFiltro] = useState(null);

  return (
    <Fragment>
      <Breadcrumbs mainTitle='Dashboard - Exportação' title='Exportação' parent='Dashboard' />
      <Container fluid className='ecommerce-page'>
        <Row>
          <FiltrarPeriodo onFiltrar={setFiltro} onLimpar={() => setFiltro(null)} />
        </Row>
        <Row>
          {graficos &&
            graficos.map((graficoData, index) => (
              <Chart key={`${index}-${JSON.stringify(filtro)}`} data={graficoData} plugin={'exportacao'} filtro={filtro} />
            ))}
        </Row>
      </Container>
    </Fragment>
  );
};

export default DashboardExportacao;
